/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Web_Search_Search_ErrorInputs */

const es_tools_web_search_search_error = /** @type {(inputs: Tools_Web_Search_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al buscar en la web`)
};

const en_tools_web_search_search_error = /** @type {(inputs: Tools_Web_Search_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error searching the web`)
};

/**
* | output |
* | --- |
* | "Error searching the web" |
*
* @param {Tools_Web_Search_Search_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_web_search_search_error = /** @type {((inputs?: Tools_Web_Search_Search_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Web_Search_Search_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_web_search_search_error(inputs)
	return en_tools_web_search_search_error(inputs)
});
export { tools_web_search_search_error as "tools.web_search.search_error" }